import { render, staticRenderFns } from "./school.vue?vue&type=template&id=5b59e954&scoped=true"
import script from "./school.vue?vue&type=script&lang=js"
export * from "./school.vue?vue&type=script&lang=js"
import style0 from "./school.vue?vue&type=style&index=0&id=5b59e954&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b59e954",
  null
  
)

export default component.exports